import Datafeed from './datafeed.js';

export function customIndicatorsGetter(PineJS) {
  return Promise.resolve([
    {
      name: 'TMFPeRatio',
      metainfo: {
        _metainfoVersion: 51,
        id: 'TMFPeRatio@tv-basicstudies-1',
        name: '* TMF PE Ratio',
        description: '* TMF PE Ratio',
        shortDescription: '* TMF PE Ratio',
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: 'price',
          precision: 2,
        },
        plots: [{ id: 'plot_0', type: 'line' }],
        defaults: {
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 1,
              plottype: 2,
              trackPrice: true,
              color: 'green',
            },
          },
          inputs: {},
        },
        styles: {
          plot_0: {
            // Output name will be displayed in the Style window
            title: 'PE Ratio',
            histogramBase: 0,
          },
        },
        inputs: [],
      },
      constructor: function(PineJs) {
        this.init = function (context, inputCallback) {
          const datafeed = Datafeed;
          this._bars = datafeed.getAllBars();
          this._context = context;
          this._input = inputCallback;

          const symbol = PineJS.Std.ticker(this._context);
          this._context.new_sym(symbol, PineJS.Std.period(this._context));
          this._context.select_sym(0);
        };
        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(0);
          const currentBarTime = PineJS.Std.time(this._context);
          const currentBar = this._bars.find(bar => bar.time === currentBarTime);

          if (currentBar) {
            return [currentBar.peRatio];
          }

          return null;
        };
      },
    },
        {
      name: 'TMFPriceToSales',
      metainfo: {
        _metainfoVersion: 51,
        id: 'TMFPriceToSales@tv-basicstudies-1',
        name: '* TMF Price to Sales',
        description: '* TMF Price to Sales',
        shortDescription: '* TMF Price to Sales',
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: 'price',
          precision: 2,
        },
        plots: [{ id: 'plot_0', type: 'line' }],
        defaults: {
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 1,
              plottype: 2,
              trackPrice: true,
              color: 'orange',
            },
          },
          inputs: {},
        },
        styles: {
          plot_0: {
            // Output name will be displayed in the Style window
            title: 'TMF Price to Sales',
            histogramBase: 0,
          },
        },
        inputs: [],
      },
      constructor: function(PineJs) {
        this.init = function (context, inputCallback) {
          const datafeed = Datafeed;
          this._bars = datafeed.getAllBars();
          this._context = context;
          this._input = inputCallback;

          const symbol = PineJS.Std.ticker(this._context);
          this._context.new_sym(symbol, PineJS.Std.period(this._context));
          this._context.select_sym(0);
        };
        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(0);
          const currentBarTime = PineJS.Std.time(this._context);
          const currentBar = this._bars.find(bar => bar.time === currentBarTime);

          if (currentBar) {
            return [currentBar.psRatio];
          }

          return null;
        };
      },
    },
    {
      name: 'TMFTotalEnterpriseValue',
      metainfo: {
        _metainfoVersion: 51,
        id: 'TMFTotalEnterpriseValue@tv-basicstudies-1',
        name: '* TMF Total Enterprise Value',
        description: '* TMF Total Enterprise Value',
        shortDescription: '* TMF Total Enterprise Value',
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: 'price',
          precision: 2,
        },
        plots: [{ id: 'plot_0', type: 'line' }],
        defaults: {
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 1,
              plottype: 2,
              trackPrice: true,
              color: 'blue',
            },
          },
          inputs: {},
        },
        styles: {
          plot_0: {
            // Output name will be displayed in the Style window
            title: 'TMF Total Enterprise Value',
            histogramBase: 0,
          },
        },
        inputs: [],
      },
      constructor: function(PineJs) {
        this.init = function (context, inputCallback) {
          const datafeed = Datafeed;
          this._bars = datafeed.getAllBars();
          this._context = context;
          this._input = inputCallback;

          const symbol = PineJS.Std.ticker(this._context);
          this._context.new_sym(symbol, PineJS.Std.period(this._context));
          this._context.select_sym(0);
        };
        this.main = function (context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(0);
          const currentBarTime = PineJS.Std.time(this._context);
          const currentBar = this._bars.find(bar => bar.time === currentBarTime);

          if (currentBar) {
            return [currentBar.totalEnterpriseValue];
          }

          return null;
        };
      },
    },
  ]);
}
